<template>
  <div>
    <el-row style="height: 40px">
      <el-col :span="24">
        <el-button type="primary" size="small" @click="showImport=true" style="margin-right: 15px">导入订单</el-button>
        <el-select v-model="sendValue" size="small" style="width: 120px" placeholder="请选择">
          <el-option
            v-for="item in sendOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="send">批量发货</el-button>
        <el-button type="primary" size="small" @click="reSend">已发货，发错重发</el-button>
        <el-button type="primary" size="small" @click="riskSend">重发风控拦截订单</el-button>
        <el-button type="primary" v-show="true" size="small" @click="showAddress=true" style="margin-right: 15px">发货地址</el-button>
        <el-button type="primary" size="small" @click="showCompany=true" style="margin-right: 15px">查看物流公司名称</el-button>


        <el-link href="./static/template/fahuo.xls"  type="primary" style="margin-left: 20px">批量发货模板</el-link>
        <el-button type="text" @click="help">查看帮助</el-button>
      </el-col>
    </el-row>
    <el-row style="height: 40px">
      <el-col><span  v-if="false" style="color: red">提示：不能发其他店铺订单，不能发已发过货的订单，检测到就会停止发货，排除错单后重新导入发货。切记！切记！切记！写这么长你该看到了吧！</span></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="logisData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '0px'}" >
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="200px"></el-table-column>
          <el-table-column  prop="oid" label="子订单号(可选)" width="200px"></el-table-column>
          <el-table-column  prop="logisNo" label="运单号" width="200px"></el-table-column>
          <el-table-column  prop="logisName" label="物流公司" width="200px"></el-table-column>

          <el-table-column  prop="status" label="状态" ></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="导入订单" :close-on-click-modal="false"
      :visible.sync="showImport"
      width="50%"
      center>
      <span style="margin-left:20px; margin-bottom: 30px">复制Excel表格里的订单，在这里粘贴（格式：订单号，子订单号，运单号，物流公司）</span>
      <el-input :rows="15" type="textarea" v-model="logisTxt" > </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="uploadData">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="物流公司名称" :close-on-click-modal="false"
      :visible.sync="showCompany"
      width="600px"
      center>
      <el-tag style="margin-right: 20px; margin-top: 20px;" :key="tag" v-for="tag in company" effect="plain" :disable-transitions="false" >{{tag}}</el-tag>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showCompany = false">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog
      title="选择发货退货地址" :close-on-click-modal="false"
      :visible.sync="showAddress"
      width="800px"
      center>
      <el-button type="primary" size="small" @click="getSellerAddress('0')">恢复默认地址</el-button>
      <el-button type="primary" size="small" @click="getSellerAddress('1')">同步淘宝地址库</el-button>

      <div style="">
        <p style="margin-left:0px; margin-bottom: 10px; font-size: 16px ">1、发货地址</p>
        <el-radio-group v-model="sendDef">
          <el-radio size="small" v-for="opt in address" :key="opt.contactId" :label="opt.contactId" style="width:600px; margin-bottom: 10px">{{opt.addr}}</el-radio>
        </el-radio-group>
      </div>

      <div>
        <p style="margin-left:0px; margin-bottom: 10px;font-size: 16px ">2、退货地址</p>
        <el-radio-group v-model="cancelDef">
          <el-radio size="small" v-for="opt in address" :key="opt.contactId" :label="opt.contactId" style="width:600px;margin-bottom: 10px">{{opt.addr}}</el-radio>
        </el-radio-group>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeDefAddress">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示" :close-on-click-modal="false"
      :visible.sync="showMsg"
      width="500px"
      center>
      <div>
        <p style="white-space: pre-wrap">{{ msg }}</p></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showMsg=false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {hideLoading, showLoading} from "../api/loading";

    export default {
        name: "Logistics",
      data(){
          return{
            deny:0,
            showImport:false,
            showCompany:false,
            showAddress:false,
            status:'WAIT_SELLER_SEND_GOODS',
            logisTxt:'',
            logisData:[],
            sendValue:'offline',
            showMsg:false,
            msg:'',
            sendOpto:[{label:'虚拟发货',value:'dummy'},{label:'自己联系',value:'offline'},{label:'线上物流',value:'online'}],
            company:[ '顺丰速运','申通快递','韵达快递', '中通快递', '极兔-原百世快递', '圆通速递', '韵达快递', '德邦快递','全峰快递',
              '优速快递','国通快递','联邦快递','全一快递','龙邦速递','快捷快递','能达速递','广东EMS',
              'EMS','EMS经济快递','中国邮政','邮政标准快递','邮政快递包裹','京广速递'],
            address1:[{contactId:'1', addr:'河南省 郑州市 经开区 经北三路53号'},{contactId:'2', addr:'陕西省 郑州市 经开区 经北三路53号'},{contactId:'3', addr:'内蒙古自治区 郑州市 经开区 经北三路53号'}],
            address:[],
            /*sendId:'3',
            getId:'',
            cancelId:'2',*/
            sendDef:'',
            getDef:'',
            cancelDef:'',
          }
      },
      methods:{
        help:function(){
          this.$router.push({name: "Help", params:{ id: 'fh'}});
        },
        indexMethod(index)
        {
          return index + 1;
        },
        //按选中发货地址发货
        changeDefAddress:function(){
          this.showAddress = false;
          console.log('sendId='+ this.sendDef);
          console.log('cancelId='+ this.cancelDef);
        },
        getLogisData:function () {
          let param={
            nick:storage.get("nick"),
          }
          $api.post("/logis/get", param, response =>{
            let dataResult = response.data;
            console.log(dataResult)
            if (dataResult.state == 1 && dataResult.message == "ok"){
                 this.logisData = dataResult.data;
              }
              else{
                this.$message.error(dataResult);
                this.$router.replace({name: "Index"});
                this.deny = 1;
              }
            })
          hideLoading();
        },
        uploadData:function () {
          this.showImport = false;
          if(this.deny == 1){
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          let param={
            nick:storage.get("nick"),
            txt: this.logisTxt
          }
          $api.post("/logis/import", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.logisTxt = '';
              this.getLogisData();
              console.log("end.")
            }
            else{
              this.$message.error(dataResult.data.message);
            }
          })

        },
        updateAddressId:function(){
          //this.sendId =  this.sendDef;
          //this.cancelId =  this.cancelDef;
          this.showAddress = false;
        },
        send:function(){
          this.status = 'WAIT_SELLER_SEND_GOODS';
          this.sendGoods();
        },
        reSend:function(){
          this.status = 'WAIT_BUYER_CONFIRM_GOODS';
          this.sendGoods();
        },
        riskSend:function(){
          this.status = 'RISK_SEND_GOODS';
          this.sendGoods();
        },

        sendGoods:function () {
          if(this.logisData.length == 0){
            this.$message.error("没有订单数据，请先导入订单后再发货！。");
            return;
          }
          if(this.deny == 1){
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          let param={
            nick:storage.get("nick"),
            status: this.status,
            sendValue: this.sendValue,
            sendId:this.sendDef,
            cancelId: this.cancelDef
          }
          $api.post("/logis/sendgoods", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.getLogisData();
              this.$message.success("批量发货完成。");
              let msg='';
              for(let i=0;i<this.logisData.length;i++){
                if((this.logisData[i].status.length>0)&&(this.logisData[i].status.indexOf('成功')==-1)){
                  msg = msg + this.logisData[i].tid + '   ' + this.logisData[i].status + '\n';
                }
              }
              if (msg.length>0){
                this.msg = msg;
                this.showMsg = true;
              }
            }
            else{
              this.$message.error(dataResult.data.message);
            }
          })
        },
        //取后地址库
        getSellerAddress:function(val){
          console.log(val);
          let param={
            nick:storage.get("nick"),
            fromTb: val
          }
          $api.post("/wlb/getAddressList", param, response =>{
            let dataResult = response.data;
            console.log(dataResult);
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.address = dataResult.data.list;
              this.sendDef = dataResult.data.sendId;
              this.cancelDef = dataResult.data.cancelId;
              console.log("取地址库成功")
            }
          })
        },


      },
      mounted(){
        this.getLogisData();
        this.getSellerAddress('0');
      }
    }
</script>

<style >


</style>



// WEBPACK FOOTER //
// src/page/Logistics.vue